<template>
  <div class="mobile_login">
    <!-- 登录 -->
    <div class="mobile_login_content">
      <h2>hecoos全域制作</h2>
      <form action="">
        <input v-model="postData.loginName" type="text" placeholder="手机/邮箱/ARTBOOK账号/Hirender账号">
        <input v-model="postData.password" type="password" placeholder="密码">
        <button :disabled="!isButtonEnabled" type="submit" @click="handleSubmit">登录</button>
      </form>
      <p>
        <span @click="jumpTo('/')">回首页</span>丨
        <span @click="jumpTo('/Register')">注册</span>丨<span
          @click="jumpTo('/forget_password')">忘记密码？</span>
      </p>
    </div>
  </div>
</template>
<script>
import { adminLogin } from "@/api/api"
import { Message } from "element-ui";
import store from "@/store";
export default {
  name: "mobile_login",
  data() {
    return {
      postData: {
        loginName: "",
        password: "",
      },
    }
  },
  computed: {
    isButtonEnabled() {
      return this.postData.password.length >= 6 && !this.loginName;
    },
  },
  methods: {
    jumpTo(url) {
      // console.log(url);
      this.$router.push(url)
    },
    // 登录
    handleSubmit() {
      adminLogin(this.postData).then(res => {
        // console.log(res);
        if (res.code === 200) {
          Message.success('登录成功');
          res.data.work_duration = parseInt(res.data.work_duration) + '年'
          store.dispatch("saveAdminUserInfo", res.data);
          localStorage.setItem("token", JSON.stringify(res.data.token));
          if (localStorage.getItem('orderMsg')) {
            this.$router.push("/SoftwareSubscriptions");
          } else {
            setTimeout(() => {
              this.$router.push("/personalCenter");
            }, 1000);
          }
        } else {
          Message.error(res.message);
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.mobile_login {
  width: 100%;
  height: 100vh;
  background: url("https://download.hecoos.com/enlightv/2025-19/b946e97c082f040312c95a399d847c29.png");
  background-size: cover;
  background-repeat: no-repeat;
  object-fit: cover;
  // background-color: #d0cad4;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;

  .mobile_login_content {
    width: 100%;
    max-width: 370px;
    background-color: #222222;
    padding: 20px;
    border-radius: 6px;
    text-align: center;

    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // gap: 10px;
    h2 {
      font-size: 24px;
      color: #fff;
      margin-bottom: 15px;
    }

    input {
      display: block;
      width: 100%;
      font-size: 14px;
      padding: 12px 8px;
      border-radius: 6px;
      border: none;
      // margin: 0 10px;
      margin-bottom: 10px;
      background-color: #333333;
      color: #757575;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    button {
      display: block;
      width: 100%;
      font-size: 18px;
      margin-top: 15px;
      padding: 8px;
      border: none;
      border-radius: 6px;
    }

    p {
      font-size: 16px;
      color: #fff;
      margin-top: 10px;
    }
  }
}
</style>
